// Regex para encontrar menções no formato @[ID]{Nome} (sem delimitador)
export const MENTION_PATTERN = /@\[(\d+)\]\{([^}]+)\}/g;

// Regex para detectar @ seguido de texto (durante digitação)
export const MENTION_DETECTION_REGEX = /@([^@\n\r.,;:!?]*)$/;

// Regex para texto que vem do banco no formato @[id]{nome completo}
export const MENTION_REGEX_FROM_DB = /@\[(\d+)\]\{([^}]+)\}/g;

// Normaliza texto adicionando delimitador \u0001 após menções que não o possuem
const normalizeMentionText = (text) => {
  if (!text) return '';
  // Garantir que cada menção tenha o delimitador \u0001 após o nome
  return text.replace(MENTION_PATTERN, (match, id, name, offset, string) => {
    const trimmedName = name.trim();
    // Se já houver o delimitador imediatamente após a menção, não adicionar
    const nextChar = string[offset + match.length];
    return `@[${id}]{${trimmedName}}` + (nextChar === '\u0001' ? '' : '\u0001');
  });
};

// Processa texto com menções e retorna HTML 
export const processMentionHTML = (html, mentionClass, currentUserId = null) => {
  if (!html) return '';
  
  // Detectar se o texto tem delimitadores \u0001 (vem da edição) ou não (vem do banco)
  const hasDelimiters = html.includes('\u0001');
  
  let processedHtml = html;
  
  if (hasDelimiters) {
    // Texto com delimitadores: iterar usando o padrão sem o caractere de controle
    const normalizedHtml = normalizeMentionText(html);
    let result = '';
    let lastIndex = 0;
    const pattern = MENTION_PATTERN;
    pattern.lastIndex = 0;
    let match;
    while ((match = pattern.exec(normalizedHtml)) !== null) {
      const [fullMatch, id, name] = match;
      const offset = match.index;
      result += normalizedHtml.substring(lastIndex, offset);
      const cleanName = name.trim();
      const hasDelim = normalizedHtml[offset + fullMatch.length] === '\u0001';
      const mentionText = `@[${id}]{${cleanName}}` + (hasDelim ? '\u0001' : '');
      const isCurrentUser = currentUserId && parseInt(id) === parseInt(currentUserId);
      const finalClass = isCurrentUser ? `${mentionClass} mention-tag-current-user` : mentionClass;
      result += `<span class="${finalClass}" data-mention-id="${id}" data-mention-text="${mentionText}" contenteditable="false">@${cleanName}</span>\u200B`;
      lastIndex = offset + fullMatch.length + (hasDelim ? 1 : 0);
      pattern.lastIndex = lastIndex;
    }
    result += normalizedHtml.substring(lastIndex);
    processedHtml = result;
  } else {
    // Texto do banco - usar regex específica para formato @[id]{nome}
    processedHtml = html.replace(MENTION_REGEX_FROM_DB, (match, id, name) => {
      const cleanName = name.trim();
      const mentionText = `@[${id}]{${cleanName}}`;
      const isCurrentUser = currentUserId && parseInt(id) === parseInt(currentUserId);
      const finalClass = isCurrentUser ? `${mentionClass} mention-tag-current-user` : mentionClass;
      return `<span class="${finalClass}" data-mention-id="${id}" data-mention-text="${mentionText}" contenteditable="false">@${cleanName}</span>\u200B`;
    });
  }
  
  // Preservar quebras de linha: converter \n em <div> para exibição
  processedHtml = processedHtml.replace(/\n/g, '<br>');
  
  return processedHtml;
};

// Detecta se há uma menção sendo digitada
export const detectMentionQuery = (textBeforeCursor) => {
  if (!textBeforeCursor) return null;
  
  const mentionMatch = textBeforeCursor.match(MENTION_DETECTION_REGEX);
  
  if (mentionMatch) {
    const query = mentionMatch[1].trim();
    return query.length >= 1 ? { query } : null;
  }
  
  return null;
};

// Extrai texto do contentEditable com formato @[ID]Nome para salvar no banco
export const extractTextWithMentions = (element) => {
  if (!element) return '';
  
  let result = '';
  
  const processNode = (node, isFirstChild) => {
    // Se é um elemento de menção, adicionar o texto formatado
    if (node.nodeType === Node.ELEMENT_NODE && node.hasAttribute('data-mention-text')) {
      result += node.getAttribute('data-mention-text');
      return; // Não processar filhos
    }
    
    // Se é um BR, adicionar quebra de linha
    if (node.nodeType === Node.ELEMENT_NODE && node.nodeName === 'BR') {
      result += '\n';
      return;
    }
    
    // Se é um DIV (exceto o primeiro), adicionar quebra de linha antes
    if (node.nodeType === Node.ELEMENT_NODE && node.nodeName === 'DIV' && !isFirstChild) {
      result += '\n';
    }
    
    // Se é um nó de texto, adicionar o conteúdo sem espaços invisíveis
    if (node.nodeType === Node.TEXT_NODE) {
      result += node.textContent.replace(/\u200B/g, '');
      return;
    }
    
    // Processar filhos recursivamente
    if (node.childNodes) {
      for (let i = 0; i < node.childNodes.length; i++) {
        processNode(node.childNodes[i], false);
      }
    }
  };
  
  // Processar todos os filhos do elemento
  for (let i = 0; i < element.childNodes.length; i++) {
    processNode(element.childNodes[i], i === 0);
  }
  
  return result;
};

